import { React, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import supabase from '../config/supabaseClient';

function Account(props) {
  const [userName, setUserName] = useState('');
  const [userData, setUserData] = useState('');
  const location = useLocation();
  let navigate = useNavigate();

  useEffect(() => {
    setUserName(location.state.userData.user.id);
    //console.log(userData);
    window.scrollTo(0, 0);
    
  });

  async function userLogOut() {
    const { error } = await supabase.auth.signOut();
    navigate('/login', { state: { userData: null}  });  
  }

  return (
    <div>
      <h2>Hello, {location.state.userData.user.email}!</h2>
      <ul>
        <li><a href='#'>Account</a></li>
        <li><a href='#'>Order History</a></li>
        <li><button onClick={() => userLogOut()}>Logout</button></li>
      </ul>
      
    </div>
  )
}

export default Account;